import { InvoiceEventType } from '@features/invoices/enums/invoiceEventType'

import { InvoiceClarificationEventType } from '../types/invoiceClarificationEventType'

const invoiceStatusEventsWithClarification = [
  InvoiceEventType.DeliveryEmailComplained,
  InvoiceEventType.DeliveryEmailFailed,
  InvoiceEventType.DeliveryReminderEmailNotsent,
  InvoiceEventType.DocumentReminderPostNotsent,
  InvoiceEventType.DeliveryBaswareEinvoiceFailureEmail,
]

export const hasInvoiceStatusEventClarification = (
  invoiceEventType: InvoiceEventType,
): invoiceEventType is InvoiceClarificationEventType => {
  return invoiceStatusEventsWithClarification.includes(invoiceEventType)
}
